import React from 'react';

export default ({
  color = '#48B0FF',
  size = 12,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M3 15.725V14.225H10.65V15.725H3ZM3 11.6V10.1H14.825V11.6H3ZM3 7.47498V5.97498H14.825V7.47498H3ZM16.3 18.975L12.9 15.575L13.95 14.5L16.3 16.825L20.925 12.2L22 13.275L16.3 18.975Z" fill={color} />
  </svg>
);
